import { gql } from '@apollo/client';

export const CREATE_TOOL_BOOKING = gql`
  mutation CreateToolBooking($input: CreateToolBookingInput!) {
    createToolBooking(input: $input) {
      toolBooking {
        id
        fromDate
        toDate
        status
      }
      errors
    }
  }
`;
